import { DarkPalletType } from './dark'

export const crossColors: DarkPalletType = {
  cross: {
    white: '#FFFFFF',
    black: '#000000',
    100: '#F2F2F2',
    200: '#C2C2C2',
    overlay: '#171717',
  },
}

export type CrossColorsType = typeof crossColors
